module.exports = __webpack_public_path__ + "facebook-9dc9bfb8.png";